import { Timestamp } from '@bufbuild/protobuf';
import { Box, Modal, Typography } from '@mui/material';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import ImageWrapper from '../../elements/ImageWrapper';
import { AssessmentEnum } from '@protos/learning_management/lms.db_pb';
import { formatRemainingTime } from '../../../commonUtils/utilFunctions';

const styles: IStyles = {
  modal: {
    boxSizing: 'border-box',
    display: { xs: 'flex' },
    alignItems: 'flex-end',
  },

  root: {
    backgroundColor: 'common.white',
    margin: 'auto',
    width: { xs: '80%', md: pxTovW(500) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    '&:focus-visible': {
      outline: 'none',
    },
  },
  lightBulbRow: {
    marginTop: { xs: pxToRem(-34), md: pxTovW(-34) },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  lightbulbWrapper: {
    backgroundColor: 'common.white',
    display: 'inline-block',
    padding: { xs: pxToRem(24), md: pxTovW(24) },
    borderRadius: '50%',
  },
  lightbulb: {
    height: { xs: pxToRem(66), md: pxTovW(66) },
    width: { xs: pxToRem(66), md: pxTovW(66) },
  },
  textStyles: {
    px: { xs: pxToRem(66), md: pxTovW(66) },
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  okButton: {
    border: '1px solid #0AF274',
    backgroundColor: 'neutral.turquoise',
    marginX: 'auto',
    marginY: { xs: pxToRem(16), md: pxTovW(16) },
    width: { xs: pxToRem(120), md: pxTovW(120) },
    p: { xs: pxToRem(16), md: pxTovW(16) },
    textAlign: 'center',
    cursor: 'pointer',
  },
};

//* Interface
interface IProps {
  startTime?: Timestamp;
  assessmentType?: AssessmentEnum;
  open: boolean;
  okHandler: () => void;
}
export const EarlyHomeworkPopup = ({
  startTime,
  assessmentType,
  open,
  okHandler,
}: IProps) => {
  const getAssessmentTypestring = (assessmentType: AssessmentEnum): string => {
    switch (assessmentType) {
      case AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT:
        return 'formative assessment';
      case AssessmentEnum.ASSESSMENT_DIAGNOSTIC_ASSESSMENT:
        return 'diagnostic assessment';

      default:
        return 'assessment';
    }
  };
  return (
    <Modal open={open} onClose={okHandler} sx={styles.modal}>
      <Box sx={styles.root}>
        <Box sx={styles.lightBulbRow}>
          <Box sx={styles.lightbulbWrapper}>
            <ImageWrapper
              name="timer"
              type="png"
              parentFolder="icons"
              styles={styles.lightbulb}
            />
          </Box>
        </Box>
        <Box sx={styles.textStyles}>
          <Typography variant="bodyText">
            {`The ${getAssessmentTypestring(
              assessmentType || AssessmentEnum.ASSESSMENT_UNDEFINED
            )} has not started yet`}
            <br />
            <br />
            {`You can attempt the ${getAssessmentTypestring(
              assessmentType || AssessmentEnum.ASSESSMENT_UNDEFINED
            )}
            in `}
          </Typography>

          <Typography variant="bodyText" fontWeight="bold">
            {formatRemainingTime(new Timestamp(startTime))}
          </Typography>
        </Box>
        <Box sx={styles.okButton} onClick={okHandler}>
          <Typography variant="bodyText">OK</Typography>
        </Box>
      </Box>
    </Modal>
  );
};
